module.exports = __webpack_public_path__ + "img/driving-license.e0309550.png";